import React from 'react'
import {useIntl} from 'react-intl'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
  faTachometerAlt,
  faMoneyBillWave,
  faChartArea,
  faMapMarkedAlt,
  faMapSigns,
  faHardHat,
  faToolbox,
  faUsers, // Added this icon for ColoradoFutureJobs
} from '@fortawesome/free-solid-svg-icons'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const broughtByLogo = 'https://luminancedata.com/wp-content/uploads/2023/10/CDWClogo2.png'
  const ceoLogo = process.env.PUBLIC_URL + '/media/logos/ceo_logo.png' // Path to your CEO logo in the public folder

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon={<FontAwesomeIcon icon={faTachometerAlt} />}
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
      />

      {/* Funding Section */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-success text-uppercase fs-8 ls-1'>Funding</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/bli-awards'
        icon={<FontAwesomeIcon icon={faMoneyBillWave} />}
        title='Funding Table'
      />
      <SidebarMenuItem
        to='/funding_by_subacategory'
        icon={<FontAwesomeIcon icon={faChartArea} />}
        title='Funding Sub-Category Charts'
      />

      {/* Maps Section */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-success text-uppercase fs-8 ls-1'>Maps</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/colorado_map'
        icon={<FontAwesomeIcon icon={faMapMarkedAlt} />}
        title='Colorado Awards Map'
      />
      <SidebarMenuItem
        to='/commuter_map'
        icon={<FontAwesomeIcon icon={faMapSigns} />}
        title='Commuter / Resident Map'
      />

      {/* Occupations Section */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-success text-uppercase fs-8 ls-1'>Occupations</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/occupations'
        icon={<FontAwesomeIcon icon={faHardHat} />}
        title='Occupation Demand'
      />
      <SidebarMenuItem
        to='/skills_transfer'
        icon={<FontAwesomeIcon icon={faToolbox} />}
        title='Construction Skills Transfer'
      />

      {/* Other Data Resources */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-success text-uppercase fs-8 ls-1'>
            Other Data Resources
          </span>
        </div>
      </div>
      <div
        onClick={(e) => {
          e.preventDefault()
          window.open('https://coloradofuturejobs.com/', '_blank')
        }}
      >
        <SidebarMenuItem
          to='#' // Dummy value
          icon={<FontAwesomeIcon icon={faUsers} />}
          title='ColoradoFutureJobs'
        />
      </div>

      {/* Adding a dashed line separator */}
      <div style={{borderTop: '1px dashed grey', margin: '10px 0'}}></div>

      {/* Adding "Brought to you by" and Logos */}
      <div className='menu-item' style={{marginTop: '20px'}}>
        <div
          className='menu-content'
          style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}
        >
          <span className='menu-title' style={{color: 'white'}}>
            Brought to you by
          </span>
          <a href='https://cwdc.colorado.gov/' target='_blank' rel='noopener noreferrer'>
            <img src={broughtByLogo} alt='Brought to you by Logo' style={{height: '75px'}} />
          </a>
          {/* CEO Logo */}
          <img src={ceoLogo} alt='CEO Logo' style={{height: '100px', marginTop: '30px'}} />
        </div>
      </div>
    </>
  )
}

export {SidebarMenuMain}
